import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserTypeResponsePipe } from './user-type-response.pipe';

@NgModule({
  declarations: [UserTypeResponsePipe],
  imports: [CommonModule],
  exports: [UserTypeResponsePipe],
})
export class UserTypeResponseModule {}
